import styled from "styled-components";

const TagList = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: ${(props) => props.$marginTop || "17px"};
`;

const TagItem = styled.span`
  border: 1px solid currentColor;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 0.65rem;
  font-weight: 700;
  color: inherit;
  opacity: 0.82;
`;

export function Tags({ items, marginTop }) {
  return (
    <TagList $marginTop={marginTop}>
      {items.map((item) => (
        <TagItem key={item}>{item}</TagItem>
      ))}
    </TagList>
  );
}
